module.exports = __webpack_public_path__ + "static/media/chevron-down.0916fb1e.svg";